enum StoreEnum {
  EU = 'eu',
  UK = 'uk',
  US = 'us',
}

export default StoreEnum;
